var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466 750c-48.6 0-95.7-9.5-140.1-28.3-42.9-18.1-81.4-44.1-114.4-77.1s-59-71.6-77.1-114.4C115.5 485.7 106 438.6 106 390c0-48.6 9.5-95.7 28.3-140.1 18.1-42.9 44.1-81.4 77.1-114.4s71.6-59 114.4-77.1C370.2 39.5 417.4 30 466 30s95.7 9.5 140.1 28.3c42.9 18.1 81.4 44.1 114.4 77.1s59 71.6 77.1 114.4C816.5 294.2 826 341.4 826 390c0 48.6-9.5 95.7-28.3 140.1-18.1 42.9-44.1 81.4-77.1 114.4s-71.6 59-114.4 77.1C561.7 740.5 514.6 750 466 750z m0-680c-176.4 0-320 143.6-320 320s143.6 320 320 320 320-143.6 320-320c0-176.5-143.6-320-320-320z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M891 817L707.1 633.2c-7.8-7.8-7.8-20.5 0-28.3 7.8-7.8 20.5-7.8 28.3 0l183.8 183.8c7.8 7.8 7.8 20.5 0 28.3-7.8 7.9-20.4 7.9-28.2 0z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.870b787c8e1f0342c0c2d56864eaa0d9.svg";
export { ForwardRef as ReactComponent };